module.exports = __webpack_public_path__ + "img/topSon.7d287c33.svg";